import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LLMStyle } from '../../../../models/enums/llm-style';
import { NgFor } from '@angular/common';


@Component({
  selector: 'app-llm-choice',
  standalone: true,
  imports: [
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    NgFor
  ],
  templateUrl: './llm-choice.component.html',
  styleUrl: './llm-choice.component.scss'
})
export class LlmChoiceComponent {
  @Input() assistantForm!: FormGroup;
  modelStyle = [LLMStyle.SMART,LLMStyle.REGULAR,LLMStyle.FASTEST,LLMStyle.CONVERSATIONAL];
}
